import UIImage from 'UIComponents/image/UIImage';
import I18n from 'I18n';

// @ts-expect-error img
import persona1 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-01.webp';
// @ts-expect-error img
import persona2 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-02.webp';
// @ts-expect-error img
import persona3 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-03.webp';
// @ts-expect-error img
import persona4 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-04.webp';
// @ts-expect-error img
import persona5 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-05.webp';
// @ts-expect-error img
import persona6 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-06.webp';
// @ts-expect-error img
import persona7 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-07.webp';
// @ts-expect-error img
import persona8 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-08.webp';
// @ts-expect-error img
import persona9 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-09.webp';
// @ts-expect-error img
import persona10 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-10.webp';
// @ts-expect-error img
import persona11 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-11.webp';
// @ts-expect-error img
import persona12 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-12.webp';
// @ts-expect-error img
import persona13 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-13.webp';
// @ts-expect-error img
import persona14 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-14.webp';
// @ts-expect-error img
import persona15 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-15.webp';
// @ts-expect-error img
import persona16 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-16.webp';
// @ts-expect-error img
import persona17 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-17.webp';
// @ts-expect-error img
import persona18 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-18.webp';
// @ts-expect-error img
import persona19 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-19.webp';
// @ts-expect-error img
import persona20 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-20.webp';
// @ts-expect-error img
import persona21 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-21.webp';
// @ts-expect-error img
import persona22 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-22.webp';
// @ts-expect-error img
import persona23 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-23.webp';
// @ts-expect-error img
import persona24 from 'bender-url!../../../images/homepage/hero-personas/thumbnail-24.webp';
import { jsx as _jsx } from "react/jsx-runtime";
const personaImages = {
  1: persona1,
  2: persona2,
  3: persona3,
  4: persona4,
  5: persona5,
  6: persona6,
  7: persona7,
  8: persona8,
  9: persona9,
  10: persona10,
  11: persona11,
  12: persona12,
  13: persona13,
  14: persona14,
  15: persona15,
  16: persona16,
  17: persona17,
  18: persona18,
  19: persona19,
  20: persona20,
  21: persona21,
  22: persona22,
  23: persona23,
  24: persona24
};
const TOTAL_NUM_OF_PERSONA_IMAGES = 24;
const NUM_OF_PERSONA_IMAGES_DISPLAYED = 6;
const getUniqueRandomNumbersBetween = (howMany, minRange, maxRange) => {
  const getRandomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };
  const randomNumbers = new Set();
  while (randomNumbers.size < howMany) {
    randomNumbers.add(getRandomIntFromInterval(minRange, maxRange));
  }
  return [...randomNumbers];
};
const uniqueRandomNumbers = getUniqueRandomNumbersBetween(NUM_OF_PERSONA_IMAGES_DISPLAYED, 1, TOTAL_NUM_OF_PERSONA_IMAGES);
const PersonaImage = ({
  imageNumber
}) => {
  return /*#__PURE__*/_jsx(UIImage, {
    alt: I18n.text('academyPublic.homepage.heroSection.personasAltText'),
    className: `persona-image persona-image--${imageNumber}`,
    height: 130,
    src: personaImages[uniqueRandomNumbers[imageNumber - 1]],
    width: 170
  });
};
export default PersonaImage;